module.exports = __webpack_public_path__ + "media/images/athletes/59-3ec798ee416836ef0397166be56e3d01.png";